export class BizParameter {
    code: string;
    name: string;
    value: string;
}